/**
 * Speech and TTS Configuration
 */

import type { OpenAIVoice, OpenAIModel } from '../types'

export const SPEECH_CONSTANTS = {
  DEFAULT_OPENAI_VOICE: 'alloy' as OpenAIVoice,
  AVAILABLE_OPENAI_VOICES: [
    'alloy',
    'echo',
    'fable',
    'onyx',
    'nova',
    'shimmer',
    'coral',
    'verse',
    'ballad',
    'ash',
    'sage',
    'marin',
    'cedar',
  ] as OpenAIVoice[],
  DEFAULT_OPENAI_MODEL: 'gpt-4o-mini-tts' as OpenAIModel,
  AVAILABLE_OPENAI_MODELS: ['gpt-4o-mini-tts', 'tts-1-hd', 'tts-1'] as OpenAIModel[],
  SPEECH_CACHE_LIMIT: 12,
  WORD_PRACTICE_SPEECH_THRESHOLD: 6,
  TRANSCRIBE_MODEL: 'gpt-4o-mini-transcribe',
  LISTEN_MAX_DURATION_MS: 7000,
  LISTEN_IDLE_STATUS_TIMEOUT_MS: 4000,
} as const

export const WORD_PRACTICE_HOMOPHONES: Record<string, string[]> = {
  sea: ['sea', 'see'],
  see: ['see', 'sea'],
  to: ['to', 'too', 'two'],
  too: ['too', 'two', 'to'],
  two: ['two', 'too', 'to'],
  heal: ['heal', 'heel'],
  heel: ['heel', 'heal'],
  won: ['won', 'one'],
  one: ['one', 'won'],
  flour: ['flour', 'flower'],
  flower: ['flower', 'flour'],
  knight: ['knight', 'night'],
  night: ['night', 'knight'],
  son: ['son', 'sun'],
  sun: ['sun', 'son'],
  right: ['right', 'write'],
  write: ['write', 'right'],
  brake: ['brake', 'break'],
  break: ['break', 'brake'],
}

export function sanitizeOpenAiVoice(candidate: string): OpenAIVoice {
  const voice = candidate as OpenAIVoice
  return SPEECH_CONSTANTS.AVAILABLE_OPENAI_VOICES.includes(voice)
    ? voice
    : SPEECH_CONSTANTS.DEFAULT_OPENAI_VOICE
}

export function sanitizeOpenAiModel(candidate: string): OpenAIModel {
  const model = candidate as OpenAIModel
  return SPEECH_CONSTANTS.AVAILABLE_OPENAI_MODELS.includes(model)
    ? model
    : SPEECH_CONSTANTS.DEFAULT_OPENAI_MODEL
}
